import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { TendersListActionsProps } from './props';
import { useTendersActions } from './hook';

export const TendersListActions = ({
    id,
    reloadData,
}: TendersListActionsProps) => {
    const { handleEdit, handleDelete } = useTendersActions(id, reloadData);

    return (
        <Grid textAlign="left" width="100%">
            <>
                <Tooltip title="Editar">
                    <IconButton size="small" onClick={handleEdit}>
                        <EditIcon
                            type="submit"
                            sx={{ color: 'primary.main' }}
                        />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Eliminar">
                    <IconButton size="small" onClick={handleDelete}>
                        <DeleteIcon
                            type="submit"
                            sx={{ color: 'primary.main' }}
                        />
                    </IconButton>
                </Tooltip>
            </>
        </Grid>
    );
};
